export const GridFilterConstants = {
  IS_NOT_EMPTY: 'isNotEmpty',
  IS_EMPTY: 'isEmpty'
};
